module.exports = __webpack_public_path__ + "img/3.0ed40fbb.png";